import React from 'react';
import { motion } from 'framer-motion';
import { Star, Quote } from 'lucide-react';
const testimonials = [{
  initials: 'VT',
  name: 'V.T.',
  role: 'Spanish Teacher · New York, NY',
  text: 'The slow-build lesson progression completely changed how my students experience grammar. Everything is already written — I just teach it. My lessons feel more professional than ever.'
}, {
  initials: 'CR',
  name: 'C.R.',
  role: 'Spanish Teacher · Los Angeles, CA',
  text: 'The emergency lessons saved me more times than I can count in my first month. Before this, I panicked when my plan fell apart. Now I just open the backup file and teach.'
}, {
  initials: 'DG',
  name: 'D.G.',
  role: 'Spanish Teacher · Dallas, TX',
  text: "I review the grammar focus before each lesson and walk in knowing exactly what I'm going to say and how I'm going to say it. The teacher guidance notes are something I use every single week."
}, {
  initials: 'AM',
  name: 'A.M.',
  role: 'Spanish Teacher · Boston, MA',
  text: "The assessment bank gave me back my evenings. I used to spend hours writing tests and creating answer keys. Now I open the file and I'm done in five minutes."
}, {
  initials: 'SR',
  name: 'S.R.',
  role: 'Spanish Teacher · Denver, CO',
  text: 'The culture lessons were a total revelation. My students talk about those lessons for weeks. They feel like a real experience — not just a reading worksheet.'
}];
export function ExtendedTestimonials() {
  return <section className="py-24 px-4 bg-navy-card" data-id="element-64" data-mp="3rowx2hoyzcfa">
      <div className="max-w-6xl mx-auto" data-id="element-65" data-mp="3mp2a2p8bf6zi">
        <div className="text-center mb-16" data-id="element-66" data-mp="3mnr2sffnvh3n">
          <h2 className="text-3xl md:text-5xl font-serif font-bold" data-id="element-67" data-mp="3hq7ndc788ya4">
            What Spanish teachers who already have their system are saying:
          </h2>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-68" data-mp="2b82f1lul2e1s">
          {testimonials.map((t, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className={`bg-black border border-navy-border p-8 rounded-2xl relative ${i === 4 ? 'md:col-span-2 lg:col-span-1' : ''}`} data-id="element-69" data-mp="26dezwdlgyvzv" data-mpi={i}>
              <Quote className="absolute top-6 right-6 text-gold/10" size={48} data-id="element-70" data-mp="1tsztwbg6mpw0" />

              <div className="flex gap-1 text-gold mb-6" data-id="element-71" data-mp="1g2d1f110lw8d">
                {[...Array(5)].map((_, j) => <Star key={j} size={16} fill="currentColor" data-id="element-72" data-mp="1k36jhdrs0gtc" data-mpi={j} />)}
              </div>

              <p className="text-gray-300 italic mb-8 relative z-10 leading-relaxed" data-id="element-73" data-mp="163nqxtbg7e25">
                "{t.text}"
              </p>

              <div className="flex items-center gap-4 mt-auto" data-id="element-74" data-mp="rg6x0jzc5972">
                <div className="w-12 h-12 rounded-full bg-gold-gradient flex items-center justify-center text-black font-bold text-lg" data-id="element-75" data-mp="rgoybv0uudlu">
                  {t.initials}
                </div>
                <div data-id="element-76" data-mp="11f4l5lsun0pj">
                  <div className="font-bold text-white" data-id="element-77" data-mp="11c9w1gyw4rps">{t.name}</div>
                  <div className="text-xs text-gold-light" data-id="element-78" data-mp="wegu504mejvb">{t.role}</div>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}